import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { noop } from 'ui-components/default-props/noop';

import { usePrintSettings } from '../../core/hooks';
import { buildDefaultPrintSetting } from '../../../../containers/print-document-button-containers/core/buildDefaultPrintSetting';
import { DocumentType } from '../../../../enums/document-type';
import PrintDocumentMenuItem from '../../../../components/print-document-menu-item';
import { useOrderSummary } from '../hooks/use-order-summary';

export const OrderSummary = ({ fulfillmentPlanIds, onClick: onClickProp = noop }) => {
  const { isDisabled, onPrint } = useOrderSummary({ fulfillmentPlanIds });

  const printSettings = usePrintSettings(DocumentType.OrderSummary.printSettingKey);

  const defaultPrintSetting = useMemo(() => buildDefaultPrintSetting(printSettings, onPrint, onPrint), [onPrint, printSettings]);

  const onClick = useCallback(() => {
    onPrint();
    onClickProp();
  }, [onPrint, onClickProp]);

  return (
    <PrintDocumentMenuItem
      defaultPrintSetting={defaultPrintSetting}
      disabled={isDisabled}
      name={DocumentType.OrderSummary.documentNameTranslation}
      onClick={onClick}
    />
  );
};

OrderSummary.propTypes = {
  fulfillmentPlanIds: PropTypes.array.isRequired,
  onClick: PropTypes.func,
};
